"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const react_router_dom_1 = require("react-router-dom");
const store_1 = require("../../../store/store");
const store_2 = require("../../../store/store");
const LoadingButton_1 = __importDefault(require("../../../components/LoadingButton"));
const InputField_1 = __importDefault(require("../../../components/InputField/InputField"));
const Alert_1 = __importDefault(require("../../../components/Alert"));
const InternalLogin = () => {
    const appSettings = (0, store_2.useAppSelector)((state) => state.app.appSettings);
    const socialSecurityStyle = appSettings === null || appSettings === void 0 ? void 0 : appSettings.socialSecurityStyle;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [loginError, setLoginError] = (0, react_1.useState)();
    const logoutBeforeLogin = () => __awaiter(void 0, void 0, void 0, function* () {
        yield axios.get('/api/auth/logout');
        yield store_1.persistor.purge();
        yield axios.get('/sanctum/csrf-cookie');
    });
    const setLoginErrorMessage = (code) => {
        switch (code) {
            case 1:
                setLoginError(__.trans('login.failed-credentials-message'));
                break;
            case 5:
                setLoginError(__.trans('login.too-many-attempts'));
                break;
            case 998:
                setLoginError(__.trans('login.validaton-error-message'));
                break;
            default:
                setLoginError('Something went wrong...');
        }
    };
    let socialSecurityPattern;
    switch (socialSecurityStyle) {
        case 'se':
            socialSecurityPattern = /^\s*\d{6}[-_\s]?\d{4}\s*$/;
            break;
        case 'no':
            socialSecurityPattern = /^\s*\d{6}[-_\s]?\d{5}\s*$/;
            break;
        default:
            socialSecurityPattern = /.*/;
    }
    const handleSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        setLoginError(null);
        values.id = _.replace(values.id, '-', '');
        logoutBeforeLogin().then(() => {
            axios
                .post('/api/auth/login', values)
                .then((response) => response.data)
                .then((data) => {
                if (data.redirect) {
                    if (data.redirect === 'change-temporary-password') {
                        navigate(data.redirect, { state: { oldPassword: values.password } });
                    }
                    else {
                        navigate(data.redirect);
                    }
                }
                if (data.message) {
                    setLoginError(data.message);
                }
            })
                .catch((error) => {
                var _a;
                setIsLoading(false);
                console.error(error);
                setLoginErrorMessage((_a = error.response.data.replyStatus) === null || _a === void 0 ? void 0 : _a.errorCode);
            });
        });
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Alert_1.default, { color: "warning", isOpen: !!loginError, children: loginError }), (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: {
                    id: '',
                    password: '',
                }, onSubmit: handleSubmit, validationSchema: yup.object().shape({
                    id: yup
                        .string()
                        .required(__.trans('login.validation-id-required'))
                        .matches(socialSecurityPattern, __.trans('login.validation-id-matches', {
                        style: socialSecurityStyle === 'se'
                            ? '990101-1234'
                            : socialSecurityStyle === 'no'
                                ? '010199-12345'
                                : '',
                    })),
                    password: yup.string().required(__.trans('login.validation-password-required')),
                }), children: (0, jsx_runtime_1.jsxs)(formik_1.Form, { children: [(0, jsx_runtime_1.jsx)(InputField_1.default, { name: 'id', id: 'id', type: 'text', autoComplete: 'username', label: __.trans('login.personal-number') }), (0, jsx_runtime_1.jsx)(InputField_1.default, { name: 'password', id: 'password', type: 'password', autoComplete: 'current-password', label: __.trans('login.password') }), (0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn theme-button-primary mt-3 w-100", children: __.trans('login.login-form-submit') }) })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex justify-content-between", children: [(0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center align-items-center p-3 flex-grow-1", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, { to: "/auth/register", children: __.trans('login.register') }) }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center align-items-center p-3 flex-grow-1", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, { to: "/auth/reset-password", children: __.trans('login.reset-password') }) })] })] }));
};
exports.default = InternalLogin;
